import React from 'react';
import cn from '@/utils/cn';
import { iconVariant } from './iconVariant';
import { IconProps } from './types/IconInterface';
import CalendarDaysSvg from '@/assets/CalendarDays.svg';

const CalendarDays = ({ size, variant, className }: IconProps) => (
  <img
    src={CalendarDaysSvg}
    className={cn(iconVariant({ variant, size, className }))}
    aria-hidden="true"
    alt=""
  />
);

export default CalendarDays;
